import { rankingItems } from '@/mocks/homepage';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">人气排行</h2>
          <p className="text-sm text-foreground-500">本周最受欢迎的漫画 TOP5</p>
        </div>
        <div className="max-w-4xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 bg-background-50 rounded-lg p-4 border border-background-200/80 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              {/* 排名 */}
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                <span className={`font-heading text-xl font-bold ${
                  item.rank === 1 ? 'text-primary-500' :
                  item.rank === 2 ? 'text-secondary-500' :
                  item.rank === 3 ? 'text-accent-500' :
                  'text-foreground-400'
                }`}>
                  {item.rank}
                </span>
              </div>
              {/* 图片 */}
              <div className="flex-shrink-0 w-20 h-14 rounded overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="80"
                  height="56"
                />
              </div>
              {/* 信息 */}
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.category}</p>
              </div>
              {/* 热度 */}
              <div className="flex-shrink-0 text-right">
                <span className="text-xs font-medium text-primary-600">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}